var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvatar = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fillOpacity: 0.08
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.75 7.78125C9.75 6.38328 10.8833 5.25 12.2812 5.25C13.6792 5.25 14.8125 6.38328 14.8125 7.78125C14.8125 9.17922 13.6792 10.3125 12.2812 10.3125C10.8833 10.3125 9.75 9.17922 9.75 7.78125ZM12.2812 4.125C10.262 4.125 8.625 5.76196 8.625 7.78125C8.625 9.80054 10.262 11.4375 12.2812 11.4375C14.3005 11.4375 15.9375 9.80054 15.9375 7.78125C15.9375 5.76196 14.3005 4.125 12.2812 4.125ZM9.75 12.5625C8.79411 12.5625 6.7985 13.0695 6.18626 13.8859C5.57635 14.6991 5.25 15.7755 5.25 16.875V17.625C5.25 18.557 6.00552 19.3125 6.9375 19.3125H17.0625C17.9945 19.3125 18.75 18.557 18.75 17.625V16.875C18.75 15.7755 18.4237 14.6991 17.8137 13.8859C17.2015 13.0695 15.2059 12.5625 14.25 12.5625H9.75ZM7.08626 14.5609C7.52892 13.9706 9.21405 13.6875 9.75 13.6875H14.25C14.7859 13.6875 16.4711 13.9706 16.9137 14.5609C17.3587 15.1542 17.625 15.9854 17.625 16.875V17.625C17.625 17.9357 17.3732 18.1875 17.0625 18.1875H6.9375C6.62684 18.1875 6.375 17.9357 6.375 17.625V16.875C6.375 15.9854 6.64128 15.1542 7.08626 14.5609Z",
  fillOpacity: 0.64
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar.5a176ff5fe8afe377a4e843e931c3157.svg";